import React from 'react';

export const VerifiedBadgeIcon = ({ width = 161, height = 160 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 161 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_546_607)">
      <path
        d="M58.018 24.1728C69.4526 11.3077 89.5536 11.3077 100.988 24.1728C105.105 28.8045 110.608 31.9819 116.678 33.2313C133.537 36.7014 143.587 54.1094 138.163 70.4446C136.21 76.3257 136.21 82.6805 138.163 88.5616C143.587 104.897 133.537 122.305 116.678 125.775C110.608 127.024 105.105 130.202 100.988 134.833C89.5536 147.698 69.4526 147.698 58.018 134.833C53.9012 130.202 48.3978 127.024 42.3282 125.775C25.4694 122.305 15.4189 104.897 20.843 88.5616C22.7959 82.6805 22.7959 76.3257 20.8431 70.4446C15.4189 54.1094 25.4694 36.7014 42.3282 33.2313C48.3978 31.9819 53.9012 28.8045 58.018 24.1728Z"
        fill="#E7F765"
      />
      <path
        d="M58.018 24.1728C69.4526 11.3077 89.5536 11.3077 100.988 24.1728C105.105 28.8045 110.608 31.9819 116.678 33.2313C133.537 36.7014 143.587 54.1094 138.163 70.4446C136.21 76.3257 136.21 82.6805 138.163 88.5616C143.587 104.897 133.537 122.305 116.678 125.775C110.608 127.024 105.105 130.202 100.988 134.833C89.5536 147.698 69.4526 147.698 58.018 134.833C53.9012 130.202 48.3978 127.024 42.3282 125.775C25.4694 122.305 15.4189 104.897 20.843 88.5616C22.7959 82.6805 22.7959 76.3257 20.8431 70.4446C15.4189 54.1094 25.4694 36.7014 42.3282 33.2313C48.3978 31.9819 53.9012 28.8045 58.018 24.1728Z"
        fill="url(#paint0_radial_546_607)"
        fill-opacity="0.6"
      />
    </g>
    <path
      d="M65.7689 94.9068L51.9751 81.113C50.4248 79.5627 47.9205 79.5627 46.3702 81.113C44.8199 82.6633 44.8199 85.1677 46.3702 86.718L62.9863 103.334C64.5366 104.884 67.041 104.884 68.5913 103.334L110.648 61.277C112.199 59.7267 112.199 57.2224 110.648 55.672C109.098 54.1217 106.594 54.1217 105.043 55.672L65.7689 94.9068Z"
      stroke="#E7F765"
      stroke-width="10"
    />
    <path
      d="M65.7689 94.9068L51.9751 81.113C50.4248 79.5627 47.9205 79.5627 46.3702 81.113C44.8199 82.6633 44.8199 85.1677 46.3702 86.718L62.9863 103.334C64.5366 104.884 67.041 104.884 68.5913 103.334L110.648 61.277C112.199 59.7267 112.199 57.2224 110.648 55.672C109.098 54.1217 106.594 54.1217 105.043 55.672L65.7689 94.9068Z"
      fill="black"
      stroke="black"
      stroke-width="4.33653"
    />
    <g filter="url(#filter1_i_546_607)">
      <path
        d="M58.018 24.1728C69.4526 11.3077 89.5536 11.3077 100.988 24.1728V24.1728C105.105 28.8045 110.608 31.9819 116.678 33.2313V33.2313C133.537 36.7014 143.587 54.1094 138.163 70.4446V70.4446C136.21 76.3257 136.21 82.6805 138.163 88.5616V88.5616C143.587 104.897 133.537 122.305 116.678 125.775V125.775C110.608 127.024 105.105 130.202 100.988 134.833V134.833C89.5536 147.698 69.4526 147.698 58.018 134.833V134.833C53.9012 130.202 48.3978 127.024 42.3282 125.775V125.775C25.4694 122.305 15.4189 104.897 20.843 88.5616V88.5616C22.7959 82.6805 22.7959 76.3257 20.843 70.4446V70.4446C15.4189 54.1094 25.4694 36.7014 42.3282 33.2313V33.2313C48.3978 31.9819 53.9012 28.8045 58.018 24.1728V24.1728Z"
        stroke="#A6B90A"
        stroke-width="3.97515"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_546_607"
        x="19.3666"
        y="14.524"
        width="120.273"
        height="141.316"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11.3576" />
        <feGaussianBlur stdDeviation="11.3576" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_546_607"
        />
      </filter>
      <filter
        id="filter1_i_546_607"
        x="17.3783"
        y="12.5364"
        width="124.25"
        height="145.291"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11.3576" />
        <feGaussianBlur stdDeviation="11.3576" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_546_607"
        />
      </filter>
      <radialGradient
        id="paint0_radial_546_607"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(65.5901 107.329) rotate(145.008) scale(72.7844)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
